import { render, staticRenderFns } from "./PartPageHavsutsikt.vue?vue&type=template&id=4a94e74c&scoped=true&"
import script from "./PartPageHavsutsikt.vue?vue&type=script&lang=js&"
export * from "./PartPageHavsutsikt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a94e74c",
  null
  
)

export default component.exports